import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-serviceCardSlider';
	$(base, context).each(function(i, el){
		setTimeout(function() {
			new Swiper (el.querySelector('.b-serviceCardSlider-container'), {
				slidesPerView: 'auto',
				spaceBetween: 16,
				navigation : {
					nextEl : el.querySelector('.b-sliderArrows-btn_next'),
					prevEl : el.querySelector('.b-sliderArrows-btn_prev')
				},
				slideClass: 'b-serviceCard',
				breakpoints: {
					1024: {
						slidesPerView: 3,
						spaceBetween: 16,
					},
					1380: {
						slidesPerView: 3,
						spaceBetween: 40,
					},
				},
			});
		});
	});
});
